import type { ActivationGroup } from '@/features/activationGroup/types'

export type RegulationObject = {
  key: string
  regulationObjectCode: string
  countryCode: string
  priceArea: string
  portfolioCode: string
  portfolioName: string
  activationGroupsCount: number
}

export function resolveRegulationObjects(activationGroups: ActivationGroup[] | null): RegulationObject[] {
  const activationGroupsHavingRegulationObjectCode =
    activationGroups?.filter((activationGroup) => !!activationGroup.regulationObjectCode) ?? []

  // Group activation groups by regulation object key
  const groupedByKey = new Map<string, ActivationGroup[]>()
  for (const activationGroup of activationGroupsHavingRegulationObjectCode) {
    const key = activationGroup.regulationObjectCode! + '@' + activationGroup.portfolio.countryCode
    const existing = groupedByKey.get(key) ?? []
    groupedByKey.set(key, [...existing, activationGroup])
  }

  // Create regulation objects with counts
  const regulationObjects: RegulationObject[] = []
  for (const [key, activationGroupsList] of groupedByKey.entries()) {
    const firstActivationGroup = activationGroupsList[0]
    regulationObjects.push({
      key,
      regulationObjectCode: firstActivationGroup.regulationObjectCode!,
      countryCode: firstActivationGroup.portfolio.countryCode,
      priceArea: firstActivationGroup.portfolio.priceArea,
      portfolioCode: firstActivationGroup.portfolio.code,
      portfolioName: firstActivationGroup.portfolio.name,
      activationGroupsCount: activationGroupsList.length,
    })
  }

  return regulationObjects
}
